export default __webpack_public_path__ + "static/media/searchIconWhite.0b723639.svg";